import { FORMAT_TYPE, SylController } from '../../schema';
import { blockLeafShortcut } from './block-leaf-shortcut';
import { inlineLeafShortcut } from './inline-leaf-shortcut';
import { createTextShortcutPlugin } from './shortcut-plugin';
import { textblockTypeTextShortcut } from './text-block-shortcut';
import { textMarkShortcut } from './text-mark-shortcut';
/**
 * it build textmatcher as textblockshortcut and return a
 * TextShortcutPlugin instance
 */
var ruleBuilder = function ($schemaMetas, enable) {
    if (enable === void 0) { enable = true; }
    var rules = [];
    for (var _i = 0, $schemaMetas_1 = $schemaMetas; _i < $schemaMetas_1.length; _i++) {
        var $meta = $schemaMetas_1[_i];
        var name_1 = $meta.name;
        var textMatcher = ($meta instanceof SylController ? $meta.textMatcher : $meta.config.textMatcher) || [];
        for (var _a = 0, textMatcher_1 = textMatcher; _a < textMatcher_1.length; _a++) {
            var textMatcherItem = textMatcher_1[_a];
            var regexps = textMatcherItem.matcher;
            if (!Array.isArray(regexps))
                regexps = [regexps];
            for (var _b = 0, regexps_1 = regexps; _b < regexps_1.length; _b++) {
                var regexp = regexps_1[_b];
                // schema textMatcher
                switch ($meta.formatType) {
                    case FORMAT_TYPE.BLOCK_ATOM:
                    case FORMAT_TYPE.BLOCK_CARD:
                        rules.push(blockLeafShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case FORMAT_TYPE.INLINE_ATOM:
                    case FORMAT_TYPE.INLINE_CARD:
                        rules.push(inlineLeafShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case FORMAT_TYPE.BLOCK:
                        rules.push(textblockTypeTextShortcut(regexp, name_1, textMatcherItem));
                        break;
                    case FORMAT_TYPE.INLINE:
                        rules.push(textMarkShortcut(regexp, name_1, textMatcherItem));
                        break;
                }
            }
        }
    }
    return createTextShortcutPlugin(rules, enable);
};
export { ruleBuilder };
//# sourceMappingURL=rule-builder.js.map